import { useIntl } from '@finn/ui-utils';
import get from 'lodash/get';
import { usePathname } from 'next/navigation';

const useGetContentPieces = ({
  pageData,
  isRedirectedPageNotExist,
  isDealClosed = false,
  isCkoUnauthorized = false,
}) => {
  const i18n = useIntl();
  const pathname = usePathname();
  let messageId = 'general.cartNotExistMessage';
  if (isRedirectedPageNotExist) {
    messageId = 'general.pageNotExistMessage';
  }
  if (isDealClosed) {
    messageId = 'general.alerts.dealClosed';
  }
  if (isCkoUnauthorized) {
    messageId = 'general.alerts.ckoUnauthorized';
  }
  const alertMessage = i18n.formatMessage(messageId);

  const labels = get(pageData, 'metadata.filter_labels', {});
  const breadcrumbRootTitle = get(
    pageData,
    'metadata.headlines_templates.cars',
    ''
  );

  // Allow to render promo in case of there is no patterns provided OR
  // In case of any of the patterns is substring of current URL
  const supportedIdsPatterns = get(
    pageData,
    'metadata.supported_url_substrings_patterns.patterns',
    []
  );
  const shouldRenderPromoSection =
    !supportedIdsPatterns.length ||
    supportedIdsPatterns.some((pattern: string) => pathname.includes(pattern));

  return {
    alertMessage,
    labels,
    breadcrumbRootTitle,
    shouldRenderPromoSection,
  };
};

export default useGetContentPieces;
